// @ts-nocheck
import PropTypes from "prop-types";
import { FileUpload } from "./FileUpload";
import { useDispatch } from "react-redux";
import { SignatureConsent } from "./SignatureModal";
import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import styles from "../contractDetails.module.css";
import WhiteFile from "./../../../assets/svgs/white-file.svg";
import { CustomIconButton } from "../../../components/Custom/CustomIconButton";
import { Close } from "@mui/icons-material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";

export default function UploadSignature({ setFields, addSignature }) {
  const [isChecked, setIsChecked] = useState(false);
  const [file, setFile] = useState(null);
  const dispatch = useDispatch();
  // NOTE: file input and upload function
  // const handleUpload = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;
  //
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     const dataUrl = reader.result;
  //
  //     const newData = { type: "Signature", text: dataUrl };
  //
  //     addSignature(newData, dispatch);
  //
  //     setFields((prev) =>
  //       prev.map((group) => {
  //         if (group.type === "Signature") {
  //           return {
  //             ...group,
  //             list: [
  //               ...group.list.slice(0, -1),
  //               newData,
  //               group.list[group.list.length - 1],
  //             ],
  //           };
  //         }
  //         return group;
  //       }),
  //     );
  //   };
  //   reader.readAsDataURL(file);
  // };

  function handleUpload(e) {
    const file = e?.target?.files[0];
    if (!file) return;
    setFile(file);
  }

  function handleFileUpload() {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;

      const newData = { type: "Signature", text: dataUrl };

      addSignature(newData, dispatch);

      setFields((prev) =>
        prev.map((group) => {
          if (group.type === "Signature") {
            return {
              ...group,
              list: [
                ...group.list.slice(0, -1),
                newData,
                group.list[group.list.length - 1],
              ],
            };
          }
          return group;
        }),
      );
    };
    reader.readAsDataURL(file);
  }

  function clearFile() {
    setFile(null);
  }

  return (
    <>
      {file ? (
        <Box className={styles["contract-file"]}>
          <CustomIconButton
            sx={{
              backgroundColor: "white",
              padding: 0,
              marginRight: "1rem",
              marginLeft: "auto",
              "&:hover": {
                backgroundColor: "white",
                opacity: "0.8",
              },
            }}
            onClick={clearFile}
          >
            <Close sx={{ fontSize: "1rem", color: "black" }} />
          </CustomIconButton>
          <Typography
            sx={{
              fontSize: "1.1rem",
              color: getCssVariableHandler({
                variableName: "--primary-pink-hex",
              }),
            }}
          >
            Selected File
          </Typography>
          <Box className={styles["one-line"]}>
            <img alt={"File image"} src={WhiteFile} />
            <Typography
              className={`${styles["label"]} ${styles["color-pink"]}`}
              sx={{
                fontSize: "0.8rem",
                cursor: "pointer",
                userSelect: "none",
                "&:active": {
                  opacity: "0.8",
                },
              }}
            >
              {file.name}
            </Typography>
          </Box>
        </Box>
      ) : (
        <FileUpload
          accept="image/png"
          fileChangeHandler={handleUpload}
          text={"Upload signature here"}
        />
      )}
      <SignatureConsent isChecked={isChecked} setIsChecked={setIsChecked} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Button
          onClick={handleFileUpload}
          className={`btnPink ${!(file && isChecked) ? "sow-btn-disabled" : ""}`}
          sx={{
            ...(!(file && isChecked) ? { cursor: "not-allowed" } : {}),
          }}
        >
          {"Save Signature"}
        </Button>
      </Box>
    </>
  );
}

UploadSignature.propTypes = {
  addSignature: PropTypes.func,
  setFields: PropTypes.func,
};